import React from 'react'

import { connect } from 'react-redux'

import { AppState } from '@chegg-wt/core/state'
import { CREATE_FOLDER_MODAL } from '@chegg-wt/core/state/modals/constants'
import { openModal } from '@chegg-wt/core/state/modals/actions'
import { foldersDataSelector } from '@chegg-wt/core/state/folders/selectors'
import FoldersListItem from './FoldersListItem'

import * as Styled from './styled'

import { FolderListProps } from './types'

export const FoldersList: React.FunctionComponent<FolderListProps> = ({
  folders,
  createFolder,
}) => (
  <Styled.FoldersListGroup data-test="folders-list">
    <Styled.CreateFolderAction
      type="button"
      onClick={createFolder}
      data-test="create-folder"
    >
      + Create folder
    </Styled.CreateFolderAction>
    <Styled.ListContainer>
      {folders.map((data, index) => (
        <FoldersListItem
          key={data.id}
          index={index}
          folderId={data.id}
          name={data.name}
          isPublic={data.public}
        />
      ))}
    </Styled.ListContainer>
  </Styled.FoldersListGroup>
)

const mapStateToProps = (state: AppState) => ({
  folders: foldersDataSelector(state),
})

const mapDispatchToProps = {
  createFolder: () => openModal({ name: CREATE_FOLDER_MODAL, data: {} }),
}

export default connect(mapStateToProps, mapDispatchToProps)(FoldersList)
